import { Component, OnInit } from '@angular/core';
import { DAO } from '../../modal/DAO';
import { Constants } from 'src/app/modal/ProjConstants.models';

@Component({
    selector: 'internalAdmin',
    templateUrl: './internalAdmin.html'
})

export class InternalAdminComponent  implements OnInit {

    public internalAdminUserActionsQuestionOptions = Constants.InternalAdminUserActions;
    public internalAdminUserAction: string;

    constructor(
        public dao: DAO
    ) {}
    ngOnInit(): void {}
}

